import classNames from 'classnames'
import styled from 'styled-components'
import { Box } from 'widgets'

const TabSelectStyled = styled.div`
  width: 100%;
  padding: 4px;

  @media (min-width: 576px) {
    width: fit-content;
  }

  > div {
    font-size: 14px;
    font-weight: 700;
    line-height: 24px;
    text-align: center;

    padding: 4px 16px;
    cursor: pointer;
  }
`

interface TabSelectDataType {
  index: number | string
  value: string | JSX.Element
}

interface TabSelectProps {
  data: TabSelectDataType[]
  onChange?: (index: number | string) => void
  active?: number | string
  className?: string
}

const TabSelect: React.FC<TabSelectProps> = ({ data, active, onChange, className }) => {
  return (
    <TabSelectStyled
      className={classNames(
        className,
        'bg-surface-background-1 rounded-lg border border-solid border-stroke-sm grid grid-flow-col auto-cols-fr',
      )}
    >
      {data?.map((item) => (
        <Box
          key={item?.index}
          className={classNames('text-text-secondary rounded-md', {
            'active bg-brand-600 !text-text-invert': active === item?.index,
          })}
          onClick={() => onChange?.(item?.index)}
        >
          {item?.value}
        </Box>
      ))}
    </TabSelectStyled>
  )
}

export default TabSelect
